import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { buildLoginUrl, getLocationReturnTo } from '../utils/authRedirect';

const PrivateRoute = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          padding: '24px',
          textAlign: 'center',
        }}
      >
        <div>
          <div style={{ fontSize: '1.15rem', fontWeight: 600 }}>Loading your workspace...</div>
          <div style={{ marginTop: '0.75rem', color: 'rgba(255,255,255,0.68)' }}>
            We&apos;re checking your session before opening this view.
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    const returnTo = getLocationReturnTo(location);
    return (
      <Navigate
        to={buildLoginUrl({ returnTo })}
        replace
        state={{ returnTo }}
      />
    );
  }

  if (requireAdmin) {
    if (!user.isAdmin) {
      // Preserve the query string -- a preview visitor (always non-admin)
      // who tries an /admin URL should not lose ?preview=1 on the bounce
      // back to /dashboard.
      return <Navigate to={{ pathname: '/dashboard', search: location.search }} replace />;
    }
  }

  return children;
};

export default PrivateRoute;
